'use client';

import * as React from 'react';

import { Modal } from '@/components/antd-wrapper/modal/global/modal';
import { Button } from 'antd';
import { Switch } from '@/components/ui/switch';
import { useEffect, useState } from 'react';
import { useGlobalConfig } from '@/contexts/global-config-context';
import {
  getUserConfigFromTargetSpace,
  updateUserConfigFromTargetSpace,
} from '@/services/user';
import FileRender from '@/components/file-render';
import { useI18n } from '@/hooks/use-i18n';
interface PrivacyAgreementModalProps {
  open: boolean;
  onClose: () => void;
}

const PrivacyAgreementModal = ({
  open,
  onClose,
}: PrivacyAgreementModalProps) => {
  const { t } = useI18n('components');
  const [checked, setChecked] = useState(true);
  const [fileUrl, setFileUrl] = useState('');
  const { globalConfig } = useGlobalConfig();
  const handelChange = async (checked: boolean) => {
    //请求接口
    try {
      await updateUserConfigFromTargetSpace({
        key: 'privacy_agreement',
        value: checked ? 'true' : 'false',
      });
      setChecked(checked);
    } catch (err) {
      console.error('Error updating user config:', err);
    }
  };
  useEffect(() => {
    const fetchUserConfig = async () => {
      try {
        const config = await getUserConfigFromTargetSpace({
          keys: ['privacy_agreement'],
        });

        // 未设置的时候初始化设置一下， 默认为true
        if (!config?.['privacy_agreement']) {
          handelChange(true);
          return;
        }

        setChecked(config['privacy_agreement'] === 'true');
      } catch (error) {
        console.error('获取用户配置失败:', error);
      }
    };

    if (open) {
      setFileUrl(globalConfig['privacy_agreement']?.value);
      fetchUserConfig();
    }
  }, [open]);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <span className="text-base color-[#000000BF] text-[18px] font-semibold text-black">
          {t('sidebar.privacyModal.title')}
        </span>
      }
      width={800}
      height={560}
      footer={null}
      className="privacy-agreement-modal"
      classNames={{
        content: '!rounded-[20px] !pb-[0]',
      }}
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 px-6 overflow-y-auto">
          <FileRender
            renderType="md"
            fileContentData={{ data: fileUrl, type: 'file' }}
          />
          <div className="flex justify-between items-center h-[40px] border-t border-[#E5E5E580]">
            <div className="text-base font-semibold text-black">
              {t('sidebar.privacyModal.improveModel')}
            </div>
            <Switch
              checked={checked ?? true}
              onCheckedChange={(checked) => handelChange(checked)}
            />
          </div>
          <div className="mt-3 text-sm text-[#000000BF] font-normal mb-4">
            {t('sidebar.privacyModal.improveModelDesc')}
          </div>
        </div>
        <div className="h-22 flex items-center px-6 flex-shrink-0">
          <Button
            onClick={onClose}
            type="primary"
            className="w-[80px] h-[40px] rounded-[8px] bg-primary hover:bg-primary/90"
          >
            {t('sidebar.privacyModal.gotIt')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyAgreementModal;
